import { propTypes } from "qrcode.react";

/**
 * 配置
 */
const CONFIG = {
    development: {

        // baseApiUrl: "http://127.0.0.1:9081", 
        // baseApiUrl: `//ba-api-dev.ajdx.com.cn`,
        baseApiUrl: "http://127.0.0.1:9081", 


        // baseApiUrl: `//ba-api.ajdx.com.cn`,
        // baseApiUrl: `//ba-api-dev.ajdx.com.cn`,
        baseImageUrl: "",
        qrUrl:"https://qr.ajdx.com.cn/qr"
    },
    production: {
        baseApiUrl: `//ba-api.ajdx.com.cn`,
        baseImageUrl: "",
        qrUrl:"https://qr.ajdx.com.cn/s"
    }

}

// console.log(process.argv,process.env);

const config = CONFIG[`${process.env.NODE_ENV}`]

export default config;


const SYS_CONFIG = {
    sysName: "",
    sysLogo: ""
};

export const getSysConfig = () => {
    return SYS_CONFIG;
};

export const initSysConfig = (values) => {

    Object.keys(values).forEach(k => SYS_CONFIG[`${k}`] = values[`${k}`]);

    // document.title = values["sysName"];
    // document.getElementById("logo-ico").setAttribute("href", `${config.baseImageUrl}/${values["sysLogo"]}`)

    return SYS_CONFIG;
}


export const getQrCodeUrl = (type,value)=>{

    return `${config.qrUrl}?type=${type}&value=${value}`;
}
